import React from 'react';
import { withTranslation } from 'react-i18next';
import {
    Chart,
    Interval,
    Tooltip,
    Coordinate,
    Axis,
    Legend
} from 'bizcharts';
import { Result } from 'antd';


class ChartRoundLeads extends React.Component {
    state = ({

    });

    render() {
        const cols = {
            percent: {
                formatter: val => {
                    val = val * 100 + '%';
                    return val;
                },
            },
        };

        const { leadsStatus, leadsList, t } = this.props;
        let lead_initial_chart_count = [];
        for (let i = 0; i < leadsStatus.length; i++) {
            lead_initial_chart_count.push({
                item: leadsStatus[i][1],
                count: 0,
                percent: 0
            });
        }

        for (let i = 0; i < lead_initial_chart_count.length; i++) {
            let temp = leadsList.filter(lead => {
                if (lead.status_display === lead_initial_chart_count[i].item)
                    return true;
            });
            console.log(temp, lead_initial_chart_count[i].item);
            lead_initial_chart_count[i].count = temp.length;
        }

        let total = 0;
        for (let i = 0; i < lead_initial_chart_count.length; i++) {
            total += lead_initial_chart_count[i].count;
        }

        const one_count_percent = 100 / total;
        for (let i = 0; i < lead_initial_chart_count.length; i++) {
            lead_initial_chart_count[i].percent = parseFloat((lead_initial_chart_count[i].count * one_count_percent).toFixed(2)) / 100;
        }

        const lead_initial_chart_count_updated = [];
        for (let i = 0; i < lead_initial_chart_count.length; i++) {
            if (lead_initial_chart_count[i].count !== 0)
                lead_initial_chart_count_updated.push({
                    item: lead_initial_chart_count[i].item,
                    count: lead_initial_chart_count[i].count,
                    percent: lead_initial_chart_count[i].percent
                });
        }

        console.log(lead_initial_chart_count_updated);
        return (
            <div>
                <p className='pStyle' style={{ textAlign: 'center' }}>{t('dashboard.chart_round_leads.leads_status_chart', "Leads status chart")}</p>
                {
                    lead_initial_chart_count_updated && lead_initial_chart_count_updated.length > 0 ?
                        <Chart height={400} data={lead_initial_chart_count_updated} scale={cols} autoFit>
                            <Coordinate type="theta" radius={0.5} />
                            <Axis visible={false} />
                            {/* <Legend visible={false} /> */}
                            <Tooltip showTitle={false} />
                            <Interval
                                position="percent"
                                adjust="stack"
                                color="item"
                                element-highlight
                                style={{
                                    lineWidth: 1,
                                    stroke: '#fff',
                                }}
                                label={['count', {
                                    content: (data) => {
                                        return `${data.item}: ${(data.percent * 100).toFixed(2)}%`;
                                    },
                                }]}
                            />
                        </Chart> :
                        <Result
                            title={t('dashboard.view.no_leads_status', "There is no leads with status set yet.")}
                        />
                }
            </div>
        );
    }
}

export default withTranslation()(ChartRoundLeads);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/ChartRoundLeads.js